<script>
  import { onMount } from 'svelte'
  import loader from '@beyonk/async-script-loader'
  import { gaStore } from './store.js'
  import { v4 as uuidv4 } from 'uuid';

  export let properties
  export let configurations = {}
  export let enabled = true
  export let scriptScheme = 'https://'

  const GA_LOCAL_STORAGE_KEY = 'gtag:clientId';

  onMount(() => {
    if (!enabled) { return }
    init()
  })

  export function init () {
    const mainProperty = properties[0]
    loader([
      {
        type: 'script',
        url: `${scriptScheme}www.googletagmanager.com/gtag/js?id=${mainProperty}`
      }
    ],
    test,
    callback
    )
  }

  function test () {
    return Boolean(window.dataLayer).valueOf() && Array.isArray(window.dataLayer)
  }

  function gtag () {
    window.dataLayer.push(arguments)
  }

  function callback () {
    window.dataLayer = window.dataLayer || []
    gtag('js', new Date())

    let clientId = null;
    if (window.localStorage) {
      // checks if user was already connected and loads client_id from localstorage
      clientId = window.localStorage.getItem(GA_LOCAL_STORAGE_KEY);
      if (!clientId) {
        clientId = uuidv4();
        window.localStorage.setItem(GA_LOCAL_STORAGE_KEY, clientId);
      }
    }

    properties.forEach(p => {
      let config = configurations[p] || {};
      if (clientId) {
        config['client_storage'] = 'none';
        config['client_id'] = clientId;
      }
      gtag('config', p, config)
    })

    return gaStore.subscribe(queue => {
      let next = queue.length && queue.shift()

      while (next) {
        const { event, data } = next
        gtag('event', event, data)
        next = queue.shift()
      }
    })
  }
</script>
